import { styled } from "@mui/material";
import GjsEditor from "@grapesjs/react";

// GjsEditor
const StyledGrapesjsEditor = styled(GjsEditor)<{ custom?: boolean }>(
  ({ theme, custom }) => ({
    "& .gjs-cv-canvas.gjs-cui": {
      width: custom ? "100%!important" : undefined,
    },
    "& .gjs-pn-panels": {
      display: custom ? "none!important" : undefined,
    },
    "& .gjs-one-bg": {
      background: theme.palette.background.default,
      color: theme.palette.text.primary,
      "& .gjs-mdl-header": {
        background: theme.palette.primary.main,
        color: "white",
      },
      "& .gjs-mdl-btn-close": {
        color: "white",
        fontSize: "36px",
        top: -6,
        opacity: 1,
      },
      "& .gjs-mdl-title": {
        fontWeight: 600,
      },
      "& .gjs-field": {
        background: "white",
        borderRadius: theme.shape.borderRadius,
      },
      "& .gjs-btn-prim": {
        background: theme.palette.primary.main,
        color: "white",
        borderRadius: theme.shape.borderRadius,
      },
      "& .gjs-am-asset": {
        background: "white",
      },
    },
    "& .gjs-four-color, .gjs-four-color-h:hover": {
      color: theme.palette.info.main,
    },
  })
);
export default StyledGrapesjsEditor;
